/** @type {Styles} */

const drawerWidth = 240

export const handleStylesWithProps = ({ open, isLocation, isRTL = false, topBannerHeight = 0 }) => {
  const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
  })

  const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    scrollbarWidth: 'none',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(${theme.spacing(8)} + 1px)`,
    },
  })

  return {
    drawerHeading: (theme, _open) => ({
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0),
      flexDirection: 'column',
      flexShrink: 0,
      ...theme.mixins.toolbar,
      ...isLocation,
    }),
    muiDrawer: (theme) => ({
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
      boxSizing: 'border-box',
      ...(open && {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': {
          ...openedMixin(theme),
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          ...(topBannerHeight > 0 && {
            paddingTop: `${topBannerHeight}px`,
          }),
        },
      }),
      ...(!open && {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': {
          ...closedMixin(theme),
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          ...(topBannerHeight > 0 && {
            paddingTop: `${topBannerHeight}px`,
          }),
        },
      }),
    }),
    logoContainer: {
      width: '100%',
      marginLeft: open && !isRTL ? 2.25 : 0,
      marginRight: open && isRTL ? 2.25 : 0,
      justifyContent: open ? (isRTL ? 'flex-end' : 'flex-start') : 'center',
    },
  }
}

export const styles = {
  companyInfo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 2,
  },
  quickSearch: {
    backgroundColor: 'transparent',
    alignSelf: 'baseline',
    marginLeft: 1,
  },
  quickSearchActive: {
    backgroundColor: 'primary.lightest !important',
    color: 'primary.main !important',
    borderColor: 'primary.main !important',
    '& .MuiSvgIcon-root': {
      color: 'primary.main !important',
    },
    '& .MuiButton-startIcon .MuiSvgIcon-root': {
      color: 'primary.main !important',
    },
    '&:hover': {
      backgroundColor: 'primary.lightest !important',
      borderColor: 'primary.main !important',
    },
  },
  quickSearchIconActive: {
    backgroundColor: 'primary.lightest !important',
    color: 'primary.main !important',
    '& .MuiSvgIcon-root': {
      color: 'primary.main !important',
    },
    '&:hover': {
      backgroundColor: 'primary.lightest !important',
    },
  },
  companyDetails: {
    display: 'flex',
    alignItems: 'center',
  },
  menuPaperStyles: {
    maxHeight: 'calc(100% - 64px)',
    borderRadius: 0,
    maxWidth: 'none',
    boxShadow: 'none',
    height: '100vh',
  },
  viewExportIcon: {
    height: 24,
    width: 24,
  },
  companyAvatar: {
    width: 40,
    height: 40,
    marginRight: 1.5,
  },
  changeButtonBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'primary.lightest',
  },
  changeButtonStyles: {
    color: 'primary.main',
    '& .MuiButton-startIcon': {
      marginTop: 1,
    },
  },
  angleRightIcon: {
    color: 'gray.56',
    fontSize: 16,
  },
  openMenuIcon: {
    fontSize: 20,
  },
  mobileUserProfile: {
    marginLeft: -2.5,
  },
  customPageLabel: { color: 'gray.80', typography: 'header4', lineHeight: 1.4 },
  menuRoot: (theme) => ({
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    '.MuiDrawer-paper': {
      backgroundColor: 'gray.0',
    },
  }),
  logoContainer: {
    cursor: 'pointer',
    alignItems: 'center',
    display: 'flex',
    height: '100%',
  },
  openedImage: {
    height: 32,
    marginTop: 4,
  },
  closedImage: {
    height: 32,
  },
  drawerHeaderBlocks: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    paddingX: 1,
    paddingY: 2,
    justifyContent: 'space-between',
    borderBottom: 1,
    borderColor: 'gray.8',
    backgroundColor: 'transparent !important',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'transparent !important',
  },
  gotoLocationHover: {
    paddingLeft: 1.5,
    color: 'primary.main',
    backgroundColor: 'transparent',
  },
  brandMobile: {
    marginTop: 1.5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 3,
  },
  brandName: {
    marginLeft: 1,
  },
  menuButton: {
    color: 'gray.40',
    width: 20,
    height: 20,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  menuList: {
    paddingTop: 2,
    paddingBottom: 0,
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflowY: 'auto',
    minHeight: 0,
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  menuListTop: {
    flexDirection: 'column',
    padding: 0,
    paddingX: 0,
    alignItems: 'flex-start',
  },
  itemButton: {
    width: '100%',
    minHeight: 36,
    paddingY: 1.5,
    paddingX: 2.5,
    borderRadius: 0,
    marginBottom: 0,
    justifyContent: 'flex-start',
    '& .MuiSvgIcon-root': {
      color: 'primary.main',
    },
    '& .MuiListItemIcon-root': {
      color: 'primary.main',
    },
    '& .MuiListItemText-primary': {
      color: 'gray.80',
    },
    '&:last-child': {
      marginBottom: 0,
    },
    '&:hover': {
      backgroundColor: 'primary.lightest',
      '& .MuiListItemIcon-root': {
        color: 'primary.main',
      },
      '& .MuiListItemText-primary': {
        color: 'primary.main',
      },
    },
  },
  customItemButton: {
    display: 'flex',
    justifyContent: 'center',
    paddingLeft: 1,
    paddingRight: 0.5,
    paddingY: 1.25,
    marginBottom: 0.5,
    '& .MuiListItemIcon-root': {
      color: 'primary.main',
    },
    '& .MuiListItemText-primary': {
      color: 'gray.80',
    },
    '&:last-child': {
      marginBottom: 0,
    },
    borderRadius: 2,
    borderColor: 'gray.12',
    borderStyle: 'solid',
    borderWidth: 1,
  },
  openedCustomItemButton: {
    borderWidth: 0,
    width: '100%',
  },
  selected: {
    '&.Mui-selected': {
      marginBottom: 0,
    },
    backgroundColor: 'primary.lightest',
    '& .MuiListItemIcon-root': {
      color: 'primary.main',
    },
    '& .MuiListItemText-primary': {
      color: 'primary.main',
    },
  },
  locationItemButton: {
    backgroundColor: 'transparent !important',
    '&:hover': {
      backgroundColor: 'primary.lightest !important',
      '& .MuiListItemIcon-root': {
        color: 'primary.main',
      },
      '& .MuiListItemText-primary': {
        color: 'primary.main',
      },
    },
  },
  selectedLocation: {
    '& .MuiListItemIcon-root': {
      color: 'primary.main',
    },
    '& .MuiListItemText-primary': {
      color: 'primary.main',
    },
  },
  itemIcon: {
    minWidth: 'auto',
    width: 20,
    marginRight: 0,
    marginLeft: 0,
    justifyContent: 'flex-start',
    display: 'flex',
    alignItems: 'center',
  },
  itemLabel: {
    margin: 0,
    marginLeft: 1.5,
    '& .MuiListItemText-primary': {
      fontWeight: 600,
      fontSize: 14,
      lineHeight: 1.43,
      margin: 0,
    },
  },
  itemLabelRTL: {
    margin: 0,
    marginRight: 1.5,
    '& .MuiListItemText-primary': {
      fontWeight: 600,
      fontSize: 14,
      lineHeight: 1.43,
      margin: 0,
      textAlign: 'right',
    },
  },
  lockedItemLabel: {
    margin: 0,
    marginLeft: 1.5,
    '& .MuiListItemText-primary': {
      fontWeight: 600,
      fontSize: 14,
      lineHeight: 1.43,
      margin: 0,
      color: 'gray.40',
    },
  },
  lockedItemLabelRTL: {
    margin: 0,
    marginRight: 1.5,
    '& .MuiListItemText-primary': {
      fontWeight: 600,
      fontSize: 14,
      lineHeight: 1.43,
      margin: 0,
      textAlign: 'right',
      color: 'gray.40',
    },
  },
  bottomItemLabel: {
    margin: 0,
    marginLeft: 2.25,
    '& .MuiListItemText-primary': {
      fontWeight: 600,
      fontSize: 14,
      lineHeight: 2,
      margin: 0,
    },
  },
  itemLabelMobile: {
    margin: 0,
    marginLeft: 1,
    '& .MuiListItemText-primary': {
      fontWeight: 600,
      fontSize: 14,
      lineHeight: 1.43,
      margin: 0,
    },
  },
  menuListFooter: {
    flexDirection: 'column',
    display: 'flex',
    marginTop: 2,
    flexWrap: 'wrap',
    borderTop: 1,
    borderColor: 'gray.12',
    paddingX: 0,
    paddingY: 1,
    '& .MuiDivider-fullWidth': {
      borderColor: 'gray.12',
    },
  },
  itemButtonFooter: {
    minHeight: 36,
    justifyContent: 'center',
    paddingX: 0,
    width: 'auto',
    marginBottom: 1,
    '& .MuiListItemIcon-root': {
      color: 'primary.main',
    },
    '& .MuiListItemText-primary': {
      color: 'gray.80',
    },
    '&:hover': {
      color: 'primary.lightest',
      backgroundColor: 'transparent',
      '& .MuiListItemIcon-root': {
        color: 'primary.main',
      },
      '& .MuiListItemText-primary': {
        color: 'primary.main',
      },
    },
  },
  itemButtonTeamAccess: {
    '& .MuiListItemIcon-root': {
      color: 'primary.main',
    },
    '&:hover': {
      backgroundColor: 'primary.lightest',
      '& .MuiListItemIcon-root': {
        color: 'primary.main',
      },
    },
  },
  itemButtonFooterRow: {
    marginBottom: 0,
    marginRight: 0.5,
  },
  itemIconFooter: {
    minWidth: 0,
    marginRight: 0,
    justifyContent: 'center',
    '& .MuiAvatar-root': {
      height: 32,
      width: 32,
    },
  },
  selectedAvatar: {
    borderWidth: 2,
    borderColor: 'primary.main',
    borderStyle: 'solid',
    borderRadius: 16,
  },
  menuIcon: {
    fontSize: 20,
    width: 20,
    height: 20,
    minWidth: 'auto',
    color: 'primary.main',
  },
  /** A plan-gated nav item's icon: the disabled grey (NOT primary green). One merged style — not a
   *  sx array over `menuIcon` — so the grey colour actually wins (emotion applies array entries as
   *  separate classes and `menuIcon`'s primary colour would otherwise win on stylesheet order). */
  lockedMenuIcon: {
    fontSize: 20,
    width: 20,
    height: 20,
    minWidth: 'auto',
    color: 'gray.40',
  },
  countBadge: {
    marginLeft: 'auto',
    minWidth: 20,
    height: 20,
    paddingX: 0.75,
    borderRadius: 10,
    backgroundColor: 'error.main',
    color: 'common.white',
    typography: 'small',
    fontWeight: 700,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  countBadgeCollapsed: {
    position: 'absolute',
    top: -6,
    right: -10,
    minWidth: 16,
    height: 16,
    paddingX: 0.5,
    borderRadius: 8,
    backgroundColor: 'error.main',
    color: 'common.white',
    fontSize: 10,
    fontWeight: 700,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  lockBadge: {
    position: 'absolute',
    top: -6,
    right: -8,
    fontSize: 13,
    color: 'gray.64',
    backgroundColor: 'background.paper',
    borderRadius: '50%',
    padding: '1px',
  },
  dividerHeader: {
    width: '100%',
    borderColor: 'gray.12',
  },
  divider: {
    width: '100%',
    marginY: 1,
    borderColor: 'gray.12',
  },
  customDivider: {
    width: 'calc(100% - 16px)',
  },
  row: {
    flexDirection: 'row',
    paddingBottom: 0,
    paddingTop: 0,
    boxShadow: '-2px -1px 2px rgba(0, 0, 0, 0.04)',
    '& .MuiDivider-fullWidth': {
      marginBottom: 0,
    },
    '& .MuiListItemButton-root': {
      paddingY: 1,
      marginBottom: 0,
    },
  },
  newSale: {
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& .MuiButtonBase-root': {
      color: 'primary.main',

      '& .MuiButton-startIcon': {
        color: 'primary.main',
      },
    },
  },
  itemButtonUser: {
    padding: 0,
    justifyContent: 'center',
  },
  root: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 99,
    background: 'white',
    boxShadow: '0px -2px 8px rgba(30, 32, 38, 0.06)',
    borderRadius: '4px 4px 0 0',
    '& .MuiPaper-rounded': {
      position: 'static',
    },
  },
  bottomNavigation: {
    boxShadow: '0px 0px 8px rgba(30, 32, 38, 0.06)',
    borderRadius: '4px 4px 0 0',
    height: 64,
  },
  items: {
    '&.MuiBottomNavigationAction-label': {
      fontSize: 12,
      fontWeight: 600,
      lineHeight: 1.33,
      color: 'grey.56',
      '&.Mui-selected': {
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.33,
      },
    },
  },
  customHeading: {
    '& .MuiTypography-root': {
      fontSize: 12,
      lineHeight: 1.33,
      fontWeight: 400,
      color: 'gray.64',
    },
    alignSelf: 'flex-start',
    marginBottom: 1.5,
    marginLeft: 1,
  },
  IconButton: {
    width: 'auto',
    padding: 0,
    color: 'primary.main',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  footerDivider: {
    marginTop: 0.5,
    marginBottom: 1,
  },
  newLinkContainer: { alignSelf: 'flex-start' },
  newLinkButton: { paddingTop: 0.25 },
  motionIconContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  verticalDivider: {},
}
